// src/components/ui/button.jsx
import React from 'react'

export function Button({ children, className = '', ...props }) {
  return (
    <button
      className={`btn-base inline-flex items-center justify-center px-4 py-2 text-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500/60 focus-visible:ring-offset-2 focus-visible:ring-offset-zinc-50 dark:focus-visible:ring-offset-zinc-950 ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
